import 'video.js/dist/video-js.css'
import 'videojs-flash'
import VueVideoPlayer from 'vue-video-player'
import Vue from 'vue'
Vue.use(VueVideoPlayer)
